import { useTranslation } from 'react-i18next';
import { Button } from '@c2fo/liquidity';
import { CompanyStatusBankAccount } from '@/enterprise/data/activationStatus';

interface BankConnectionCardProps {
  bankAccount: CompanyStatusBankAccount | null;
  connectLoading: boolean;
  onConnect: () => void;
  onFinishVerification: () => void;
}

// Renders just the Connect/Finish Verification CTA — it sits in the step header where an
// AccordionTrigger normally would, since step 2 isn't collapsible. PlaidModal itself is rendered
// by the parent, outside the accordion, so it isn't torn down by an accordion re-render the
// instant the bank account's status flips to 'active' (which would dismiss its own "Bank Account
// Connected" confirmation before the user closes it).
const BankConnectionCard = ({
  bankAccount,
  connectLoading,
  onConnect,
  onFinishVerification,
}: BankConnectionCardProps) => {
  const { t } = useTranslation();

  if (bankAccount?.status === 'active') {
    return null;
  }

  if (bankAccount?.status === 'pending_manual_verification') {
    return (
      <Button variant="primary" loading={connectLoading} onClick={onFinishVerification}>
        {t('instantPay.onboarding.connectBank.finishVerificationCta')}
      </Button>
    );
  }

  return (
    <Button variant="primary" loading={connectLoading} onClick={onConnect}>
      {t('instantPay.onboarding.connectBank.cta')}
    </Button>
  );
};

export default BankConnectionCard;
